// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M22,5v1H2V5H22z M2,12.5h20v-1H2V12.5z M2,19h20v-1H2V19z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-burger-Epx3OLvi.js.map
